<template>
  <div class="view-container">
    <div
      v-if="slots.title || slots.right"
      class="title-container"
    >
      <div>
        <slot name="title" />
      </div>
      <slot name="right" />
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSlots } from 'vue';
const slots = useSlots();
</script>

<style scoped lang="scss">
.view-container {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 48px;
  @include clamp-all('padding', 36px);
  & .content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 48px;
  }

  & .title-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px 24px;
    // Geri linki/başlık sıkışmaz; sağdaki butonlar sığmazsa alt satıra geçer.
    & > div:first-child {
      flex-shrink: 0;
    }
    .title {
      font-weight: 600;
      font-size: $text-size-xxxl;
      line-height: 120%;
      letter-spacing: -0.02em;
      color: $text;
    }
  }
}
</style>
